export default __webpack_public_path__ + "315f027cb7f301edf5d622c4bfa80c71.png";